import React, { ReactElement } from 'react'
import { Navigation } from '../components/molecules/navigation/navigation'
import SideNav from '../components/organisms/side-nav/side-nav'
import './layout.scss'

interface ILayout {
  children: ReactElement
}
export const Layout: React.FC<ILayout> = ({ children }) => {
  return (
    <div className="layout">
      <div className="left">
        <SideNav />
      </div>
      <div className="right">
        <Navigation />
        {children}
      </div>
    </div>
  )
}

export default Layout
